import React from 'react'
import { createUseStyles } from 'react-jss'

import SVG from '../../SVG/SVG'

const useStyles = createUseStyles(theme => ({
  bookingSearchButton: {
    background: '#8C0B20',
    border: '2px solid rgba(255, 255, 255, 0.5)',
    cursor: 'pointer',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.fontFamily,
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: '0.38px',
    lineHeight: '16px',
    marginBottom: 0,
    borderRadius: '40px',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 20,
    paddingTop: 21,
    paddingLeft: 20,
    paddingRight: 20,
    textDecoration: 'none',
    transition: `background-color ${theme.animations.animate}, color ${theme.animations.animate}`,

    '&:hover': {
      //backgroundColor: theme.colors.sunflower,
    },

    '&.disabled': {
      backgroundColor: theme.colors.warmGrey,
      color: theme.colors.darkergrey,
    },
    '& svg': {
      marginBottom: 0,
      height: 16,
      width: 'auto',
      marginRight: 12,
    },
    '&.disabled svg path': {
      fill: `${theme.colors.darkergrey}`,
    },
  },
  bookingTitle: {
    ...theme.headings.BookingSearchButtonHeading,
    color: theme.colors.white,
    margin: 0,
    paddingBottom: 17,
    paddingTop: 19,
  },
}))

const BookingSearchButton = props => {
  const classes = useStyles()
  return (
    <button
      onClick={() => props.onClick()}
      className={`${classes.bookingSearchButton} ${props.disabled ? 'disabled' : ''}`}
      disabled={props.disabled}
    >
      <SVG name={'Search'} width={26} height={28} colorOne={'#fff'} />
      <span className={classes.text}>{props.children}</span>
    </button>
  )
}

export default BookingSearchButton
